import { Component } from 'react';
import { FlowNodeTypes } from '../../../powerFlowShared/components/types';
export default class HiddenModal extends Component {
    componentDidMount() {
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { badges: [], childIds: [], icon: 'i-done', isAction: false, isEditable: false, isRemovable: true, nodeType: FlowNodeTypes.CLOSE, overlay: [], payload: null, text: 'Close email' });
        this.props.replaceNode(nodeOptions);
        this.props.triggerClose();
    }
    render() {
        return null;
    }
}
